export const CHECKBOX = 'checkbox';
export const MARK_AS_READ = 'Mark As Read';
export const TABLE_HEADERS = 'table_headers';